import { createFileRoute } from '@tanstack/react-router'

import { ProjectTestPlansPage } from '@/components/qa/project-test-plans'
import { useFollowProjectClient } from '@/hooks/use-current-client'

/** #365 : les recettes d'un projet, à côté du cahier des charges et des livrables. */
export const Route = createFileRoute('/_app/projects/$projectRef_/recettes')({
  component: TestPlansRoutePage,
})

function TestPlansRoutePage() {
  const { projectRef } = Route.useParams()
  useFollowProjectClient(projectRef)
  return <ProjectTestPlansPage projectRef={projectRef} />
}
